import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Updated imports
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Popup from "./Components/popup";
import AddBanner from "./Components/AddBanner";
import Banner from "./Components/Banner";
import AddReviews from "./Components/AddReviews";
import Reviews from "./Components/Reviews";
import CarsMaker from "./Components/CarsMaker";
import AllVehicles from "./Components/AllVehicles";
import ThirdPartyVehicles from "./Components/ThirdPartyVehicles";
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from "./Components/Home";
import AboutUs from "./Components/AboutUs";
import MissionVision from "./Components/MissionVision";
import Terms from "./Components/Terms";
import WhyChooseUs from "./Components/WhyChooseUs";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import CompanyProfile from "./Components/CompanyProfile";
import HowToBuy from "./Components/HowToBuy";
import SearchCars from "./Components/SearchCars";
import Contact from "./Components/Contact";
import Login from "./Components/Login";
import AdminPanel from "./Components/AdminPanel";
import Register from "./Components/Register";
import BankingDetails from "./Components/BankingDetails";
import Auction from "./Components/Auction";
import ChassisCheck from "./Components/ChassisCheck";
import Shipping from "./Components/Shipping";
import CarReviews from "./Components/CarReviews";
import FAQPage from "./Components/FAQPage";
import ViewUser from "./Components/ViewUser";
import CreateAccount from "./Components/CreateAccount";
import AddVehicle from "./Components/AddVehicle";
import Vehicles from "./Components/Vehicles";
import AddVehicleThirdparty from "./Components/AddThirdParty";
import ThirdParty from "./Components/ThirdParty";
import CarManagementSystem from "./Components/CarManagementSystem";
import EditVehicles from "./Components/EditVehicles";
import EditVehiclesThirdParty from "./Components/EditVehiclesThirdParty";
import VehicleDetails from "./Components/VehicleDetails";
import SearchResult from "./Components/SearchResult";
import SearchIndividual from "./Components/SearchIndividual";
import Portfolio from "./Components/Portfolio";
import AddSale from "./Components/AddSale";
import ViewSales from "./Components/ViewSales";
import ViewPurchase from "./Components/ViewPurchase";
import Accounts from "./Components/Accounts";
import DocsShip from "./Components/DocsShip";
import ViewPayments from "./Components/ViewPayments";
import VehiclesCost from "./Components/VehiclesCost";
import ViewVolet from "./Components/ViewVolet";
import CreateVolet from "./Components/CreateVolet";
import AllocatedPayments from "./Components/AllocatedPayments";
import CreateAllocate from "./Components/CreateAllocate";
import AllocateVehicle from "./Components/AllocateVehicle";
import ClientAccounts from "./Components/ClientAccounts";
import PurchasedVehicles from "./Components/PurchasedVehicles";
import VehicleImages from "./Components/VehicleImages";
import ViewDocs from "./Components/ViewDocs";
import SearchVehicle from "./Components/SearchVehicle";
import Invoice from "./Components/Invoice";
import InvoicePreview from './Components/InvoicePreview'; // Add this import
import PurchasedImages from './Components/PurchasedImages';
import ViewPurchaseDocs from './Components/ViewPurchaseDocs';
import RefundAmount from './Components/RefundAmount';
import PanelAuction from './Components/PanelAuction';
import CalculatorEdit from './Components/CalculatorEdit';
import ReviewCarousel from "./Components/ReviewCarousel";

function App() {
  return (
    <Router> {/* Use BrowserRouter as Router */}
      <Navbar />
      <Popup />
      <Routes>
        {/* <Route path="/" element={<popup />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/banner" element={<Banner />} />
        <Route path="/add-banner" element={<AddBanner />} />
        <Route path="/add-reviews" element={<AddReviews />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/AllVehicles" element={<AllVehicles />} />
        <Route path="/ThirdPartyVehicles" element={<ThirdPartyVehicles />} />
        <Route path="/mission-vision" element={<MissionVision />} />
        <Route path="/terms-condition" element={<Terms />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />
        <Route path="/customer-reviews" element={<ReviewCarousel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/company-profile" element={<CompanyProfile />} />
        <Route path="/how-to-buy" element={<HowToBuy />} />
        <Route path="/search-cars" element={<SearchCars />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/banking-details" element={<BankingDetails />} />
        <Route path="/mijapan-auction" element={<Auction />} />
        <Route path="/chassis-check" element={<ChassisCheck />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/car-reviews" element={<CarReviews />} />
        <Route path="/faq-page" element={<FAQPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/view-user" element={<ViewUser />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/add-vehicle" element={<AddVehicle />} />
        <Route path="/vehicles" element={<Vehicles />} />
        <Route path="/add-thirdParty" element={<AddVehicleThirdparty />} />
        <Route path="/thirdParty" element={<ThirdParty />} />
        <Route path="/register" element={<Register />} />
        <Route path="/CarManagementSystem" element={<CarManagementSystem />} />
        <Route path="/edit-vehicle/:id" element={<EditVehicles />} />
        <Route path="/edit-vehicleThirdParty/:id" element={<EditVehiclesThirdParty />} />
        <Route path="/vehicle-details/:carId" element={<VehicleDetails />} />
        {/* <Route path="/:carId" element={<CarsMaker />} /> */}
        <Route path="/:maker" element={<CarsMaker />} />
        <Route path="/search-result" element={<SearchResult />} />
        <Route path="/search-individual" element={<SearchIndividual />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/add-new-sale" element={<AddSale />} />
        <Route path="/view-sales" element={<ViewSales />} />
        <Route path="/view-purchase" element={<ViewPurchase />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/documents-shipping" element={<DocsShip />} />
        <Route path="/payments" element={<ViewPayments />} />
        <Route path="/vehicles-cost" element={<VehiclesCost />} />
        <Route path="/volet" element={<ViewVolet />} />
        <Route path="/create-volet" element={<CreateVolet />} />
        <Route path="/view-payments" element={<AllocatedPayments />} />
        <Route path="/create-allocate" element={<CreateAllocate />} />
        <Route path="/allocate-vehicle/:stock_id" element={<AllocateVehicle />} />
        <Route path="/client-accounts" element={<ClientAccounts />} />
        <Route path="/purchased-vehicles" element={<PurchasedVehicles />} />
        <Route path="/vehicle-images/:id" element={<VehicleImages />} />        
        <Route path="/view-docs/:id" element={<ViewDocs />} />
        <Route path="/search-vehicles" element={<SearchVehicle />} />
        <Route path="/invoice/:id" element={<Invoice />} />
        <Route path="/invoice-preview/:id" element={<InvoicePreview />} />
        <Route path="/purchased-images/:id" element={<PurchasedImages />} />
        <Route path="/view-purchase-docs/:stockId" element={<ViewPurchaseDocs />} />
        <Route path="/refund-amount" element={<RefundAmount />} />
        <Route path="/panel-auction" element={<PanelAuction />} />
        <Route path="/calculator-edit" element={<CalculatorEdit />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
